var _rect, _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgElementDesktopLogo = function SvgElementDesktopLogo(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#element-desktop-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "element-desktop-logo_svg__b",
    width: 1024,
    height: 1025,
    x: 0,
    y: -1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1023,
    height: 1023,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#8D8D8D",
    rx: 265.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#element-desktop-logo_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1024v1024H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#element-desktop-logo_svg__c)",
    d: "M0 0h1024v1024H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#element-desktop-logo_svg__d)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#element-desktop-logo_svg__e)",
    d: "M512 106c224.228 0 406 181.772 406 406S736.228 918 512 918 106 736.228 106 512s181.772-406 406-406"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#element-desktop-logo_svg__f)",
    strokeWidth: 8,
    d: "M512 106c224.228 0 406 181.772 406 406S736.228 918 512 918 106 736.228 106 512s181.772-406 406-406Z",
    style: {
      mixBlendMode: "color-burn"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    clipRule: "evenodd",
    filter: "url(#element-desktop-logo_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.051 293.072c0-16.547 13.442-29.961 30.024-29.961 112.383 0 203.489 90.916 203.489 203.067 0 16.547-13.442 29.961-30.024 29.961-16.581 0-30.023-13.414-30.023-29.961 0-79.057-64.221-143.145-143.442-143.145-16.582 0-30.024-13.414-30.024-29.961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.866 436.217c16.581 0 30.023 13.414 30.023 29.961 0 112.15-91.105 203.066-203.489 203.066-16.581 0-30.023-13.414-30.023-29.961s13.442-29.96 30.023-29.96c79.221 0 143.443-64.089 143.443-143.145 0-16.547 13.442-29.961 30.023-29.961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.421 730.924c0 16.547-13.442 29.96-30.023 29.96-112.384 0-203.489-90.916-203.489-203.066 0-16.547 13.442-29.961 30.023-29.961s30.023 13.414 30.023 29.961c0 79.057 64.221 143.145 143.443 143.145 16.581 0 30.023 13.414 30.023 29.961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.134 587.779c-16.581 0-30.023-13.414-30.023-29.961 0-112.15 91.105-203.067 203.489-203.067 16.582 0 30.023 13.414 30.023 29.961s-13.441 29.961-30.023 29.961c-79.221 0-143.442 64.088-143.442 143.145 0 16.547-13.442 29.961-30.024 29.961"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "element-desktop-logo_svg__c",
    x1: 512,
    x2: 512,
    y1: 1024,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04B96A",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#07B661",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00B85C",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#16BB69",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#16BB79",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "element-desktop-logo_svg__e",
    x1: 512,
    x2: 512,
    y1: 102,
    y2: 922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98E1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#0BC491"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#007A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "element-desktop-logo_svg__f",
    x1: 512,
    x2: 512,
    y1: 102,
    y2: 922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16BB79",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#16BB69",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00B85C",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#07B661",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04B96A",
    stopOpacity: 0.41
  })), /*#__PURE__*/React.createElement("filter", {
    id: "element-desktop-logo_svg__d",
    width: 1060,
    height: 1266,
    x: -18,
    y: 78,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_178_1078"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 76
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_178_1078",
    result: "effect2_dropShadow_178_1078"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 170
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 51
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_178_1078",
    result: "effect3_dropShadow_178_1078"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 302
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow_178_1078",
    result: "effect4_dropShadow_178_1078"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect4_dropShadow_178_1078",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "element-desktop-logo_svg__g",
    width: 537.778,
    height: 537.773,
    x: 243.111,
    y: 247.111,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_178_1078"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_178_1078",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.596078 0 0 0 0 0.882353 0 0 0 0 0.756863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_178_1078"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "element-desktop-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1024v1024H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgElementDesktopLogo);
export { ForwardRef as Icon };
export default "img/element-desktop-logo.f4b4c62.svg";